'use strict'

$(function() {
  let abc = $('.remove_span > a').text();
  console.log(abc);
})

// のしよう
$(function() {
  $('#noshi_checked').change(function() {
    $('.noshi_wrap').toggleClass('noshi_on');

    if($(this).is(':checked')) {
      console.log('Doit')
      $('#inputState').removeAttr('disabled');
      $('#noshi_name').removeAttr('disabled');
      $('#inputState').attr({required: 'required'});
      $('#noshi_name').attr({required: 'required'});
    } else {
      $('#inputState').removeAttr('required');
      $('#noshi_name').removeAttr('required');
      $('#inputState').attr({disabled: 'disabled'});
      $('#noshi_name').attr({disabled: 'disabled'});
    }
    })

  $("#inputState").change(function() {
    var extraction_val = $("#inputState").val();
    if(extraction_val == "その他ご要望") {
      $('#tr_writer').attr({
        type: 'text',
        required: 'required'
      });
      $('#tr_writer').removeAttr('disabled');
    } else {
      $('#tr_writer').attr({
        type: 'hidden',
        disabled: 'disabled'
      });
      $('#tr_writer').removeAttr('required');
    }
   });
});